export default "__VITE_ASSET__Btu6hgmJ__"